module.exports = " <div class=form-section-element> <h4 class=form-section-title v-if=section.title>{{ section.title }}</h4> <div class=form-section-info v-show=section.subtitle>{{ section.subtitle }}</div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/FormSection.vue
// module id = 694
// module chunks = 2